// extracted by mini-css-extract-plugin
export default {"normalcn":"styles_normalcn__ja1Q3","normalen":"styles_normalen__7IiIA"};